import { render, staticRenderFns } from "./PedidosInternosForm.vue?vue&type=template&id=5ed00d0f"
import script from "./PedidosInternosForm.vue?vue&type=script&lang=js"
export * from "./PedidosInternosForm.vue?vue&type=script&lang=js"
import style0 from "./PedidosInternosForm.vue?vue&type=style&index=0&id=5ed00d0f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports